module.exports = __webpack_public_path__ + "static/media/logo-touche-finale.21e27b13.jpg";